export function reais(valor) {
    return arredonda(valor * 100);
}
export function formatBRL(c) {
    // toLocaleString devolve espaco NAO-QUEBRAVEL (U+00A0) entre "R$" e o numero,
    // e isso varia com a versao do ICU. O texto de confirmacao e armazenado e
    // comparado como artefato juridico, entao a saida precisa ser estavel.
    return (c / 100)
        .toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        .replace(/\u00a0/g, " ");
}
/** Arredondamento meio-para-cima, como manda a legislacao tributaria. */
export function arredonda(valor) {
    return Math.sign(valor) * Math.round(Math.abs(valor) + Number.EPSILON);
}
/** Aplica um percentual (ex.: 0.075) sobre um valor em centavos. */
export function percentual(base, taxa) {
    return arredonda(base * taxa);
}
export function soma(...valores) {
    return valores.reduce((a, b) => a + b, 0);
}
//# sourceMappingURL=dinheiro.js.map